var _rect, _rect2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyingIntent2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.949219,
    width: 42,
    height: 42,
    rx: 12,
    fill: "url(#paint0_radial_4067_43606)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.44922,
    width: 41,
    height: 41,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7458 14.8646H17.0791C15.679 14.8646 14.9789 14.8646 14.4441 15.1371C13.9737 15.3768 13.5913 15.7592 13.3516 16.2296C13.0791 16.7644 13.0791 17.4645 13.0791 18.8646V25.8646C13.0791 27.2647 13.0791 27.9648 13.3516 28.4996C13.5913 28.97 13.9737 29.3524 14.4441 29.5921C14.9789 29.8646 15.679 29.8646 17.0791 29.8646H24.0791C25.4792 29.8646 26.1793 29.8646 26.7141 29.5921C27.1845 29.3524 27.5669 28.97 27.8066 28.4996C28.0791 27.9648 28.0791 27.2647 28.0791 25.8646V23.1979M20.5791 19.0312H23.9124V22.3646M23.4958 15.2812V14.0312M26.7786 16.1651L27.6624 15.2812M27.671 19.4479H28.921M13.0791 23.4872C13.6224 23.5711 14.179 23.6146 14.7458 23.6146C18.4011 23.6146 21.6335 21.8042 23.5955 19.0312",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4067_43606)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 37.5,
    y1: 21.9492,
    x2: 37.5,
    y2: 26.9492,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 24.4492,
    x2: 40,
    y2: 24.4492,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 8.94922,
    x2: 11.5,
    y2: 13.9492,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 11.4492,
    x2: 14,
    y2: 11.4492,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.6992,
    y1: 34.9492,
    x2: 10.6992,
    y2: 37.9492,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 36.25,
    x2: 12,
    y2: 36.25,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 10.4492,
    x2: 36,
    y2: 10.4492,
    stroke: "white",
    strokeOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4067_43606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.085 -82.0508) rotate(87.4648) scale(180.677 84.5178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0432605,
    stopColor: "#81DDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3F5DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C316E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4067_43606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 32,
    fill: "white",
    transform: "translate(9 5.94922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyingIntent2);
export default __webpack_public_path__ + "static/media/buying-intent2.72db3419f4838ae6ef5af2ccc701d50e.svg";
export { ForwardRef as ReactComponent };